import CarPaperForm from './forms/CarPaperForm';
import EquinorAccident from './forms/Equinor/EquinorAccidentForm';
import EquinorDeathForm from './forms/Equinor/EquinorDeathForm';
import { FormContainer as EquinorFormContainer } from './forms/Equinor/Travel/FormContainer';
import SportInjury from './forms/SportInjuryForm';
import SportInjuryUihsForm from './forms/SportInjuryUihsForm';
import TempPage from './TempPage';

const App = () => {
  const pathLocation = window.location.pathname;
  if (pathLocation.endsWith('skademeldingsskjema')) {
    return <CarPaperForm />;
  }
  if (pathLocation.endsWith('skademelding-uihs')) {
    return <SportInjuryUihsForm />;
  }
  if (pathLocation.endsWith('skademelding')) {
    return <SportInjury />;
  }
  if (pathLocation.endsWith('claim-form-accident-illness')) {
    return <EquinorAccident />;
  }
  if (pathLocation.endsWith('claim-form-death')) {
    return <EquinorDeathForm />;
  }
  if (pathLocation.includes('claims-equinor-eng')) {
    return <EquinorFormContainer path={pathLocation} />;
  }
  return <TempPage />;
};

export default App;
